/**
 * Line
 * 
 * @Author: Focci
 * @Date: 2023-07-17 16:07:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-17 16:07:44
 */

import PropTypes from 'prop-types'
import { lineString } from '@turf/turf'
import { Source, Layer } from 'react-map-gl'
import { useMemo, useId } from 'react'
import { objectCoordToArray } from '@lib/utils'

export default function PolyLine({
  data = [], // [{lng: 174.76081567, lat: -36.86834371}, ...]
  color = '#0f9e01',
  linePaint = null,
}) {
  const id = useId()
  const boundary = useMemo(() => {
    let res = []
    try{
      const coods = objectCoordToArray(data)
      res = coods.length > 0 ? lineString(coods) : []
    } catch(err) { /**/ }
    
    return res
  }, [data])

  if(boundary.length === 0) {
    return null
  }
  
  return (
    <Source 
      id={id}
      type="geojson" 
      data={boundary}
    >
      <Layer
        type="line" 
        source={id}
        paint={{ 
          'line-width': 3, 
          'line-color': color,
          ...linePaint,
        }}
      />
    </Source>
  )
}

PolyLine.propTypes = {
  data: PropTypes.array,
  color: PropTypes.string,
  linePaint: PropTypes.object,
}
